<template>
   <div>
    <div class="table">
			<template>
        <div v-for="(item,index) in list" :key="index">
          <p>保障人信息 {{ index + 1 }}</p>
				<ul>
					<li>保障人姓名：1231</li>
					<li>保障人证件号：1231</li>
					<li>保障人生日：123123</li>
				</ul>
				<p>保障信息</p>
				<ul>
					<li>
						激活日期：12312313
					</li>
           <li>
						保障凭证：
						<a class="blue" >无</a>
					</li>
					<li>
						保险保单：	
						<a class="blue" >无</a>
					</li> 
					<!-- <li>
						保障凭证：
						<a v-if="messageData.sale.serviceCredential" target="_blank" class="blue" :href="messageData.sale.serviceCredential">查看凭证</a>
						<a v-else class="blue" >无</a>
					</li>
					<li>
						保险保单：
						<a v-if="messageData.sale.policyUrl" target="_blank" class="blue" :href="messageData.sale.policyUrl">查看保单</a>
						<a v-else class="blue" >无</a>
					</li> -->
				</ul>
        </div>
			</template>
		</div>
   </div>
</template>
<script>
export default {
  data() {
    return {
      list:[{},{},{}]
    }
  }
}
</script>
<style scoped>
.table {
	margin-top: 20px;
	margin-left: 100px;
	height: calc(100vh - 250px);
}
.searchBox {
	text-align: center;
}
.table ul {
	overflow: hidden;
	margin-left: 20px;
}
.table p {
	margin-top: 30px;
}
.table ul li {
	float: left;
	width: 33%;
	margin-top: 10px;
	line-height: 30px;
	font-size: 14px;
	color: #666;
}
.btn{text-align: center;}
.btn1{display: block;margin: 0 auto;}
</style>


// WEBPACK FOOTER //
// src/views/shop/history.vue